import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store';

import App from '@/components/App'
import Login from '@/components/Login'
import Settings from '@/components/Settings'
import UserOverview from '@/components/UserOverview'
import FoxOverview from '@/components/FoxOverview'
import PoiOverview from '@/components/PoiOverview'
import Car from '@/components/Car'
import Map from '@/components/Map'

Vue.use(Router)


export default new Router({
  routes: [
    { 
      path: '/',
      beforeEnter: (to, from, next) => {
        store.dispatch('init').then(() => {
          next();
        }).catch(() => {
          next('/login');
        });
      },
      component: App,
      children: [
        { path: '/', name: 'map', component: Map },
        { path: '/settings', name: 'settings', component: Settings },
        { path: '/users', name: 'user-overview', component: UserOverview },
        { path: '/foxes', name: 'fox-overview', component: FoxOverview },
        { path: '/pois', name: 'poi-overview', component: PoiOverview}
      ]
    },
    { path: '/login', name: 'login', component: Login },
    { path: '/car', name: 'car', component: Car}
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js